import { Outlet } from 'react-router-dom'

import { Trans } from '@/components'
import { Button } from '@/components/base/Button'
import { EmptyView } from '@/components/EmptyView'
import { useUserStore } from '@/stores/user'

export function PrivateRegionPage() {
  const privateRegionPermission = useUserStore((state) => state.privateRegionPermission)

  // Show EmptyView if user doesn't have permission
  if (!privateRegionPermission) {
    return (
      <div className="card bg-panel-white h-full flex flex-col">
        <div className="h6 pb-8 border-b border-neutral-200 mb-8">
          <Trans ns="privateRegion" i18nKey="title">
            Private Region
          </Trans>
        </div>
        <div className="w-full flex-1 flex items-center justify-center">
          <div className="max-w-[600px]">
            <EmptyView
              title={
                <Trans ns="privateRegion" i18nKey="earlyAccessTitle">
                  Early Access Feature
                </Trans>
              }
              content={
                <Trans
                  ns="privateRegion"
                  i18nKey="earlyAccessContent"
                  components={{
                    1: <a className="text-highlight" target="_blank" href="https://glows.ai" />,
                  }}
                >
                  Seamlessly extend your on-premise or personal compute to Glows.ai. Contact our
                  team to request early access.
                </Trans>
              }
              className="text-center"
              action={
                <Button
                  type="secondary"
                  className="mt-4"
                  onClick={() => window.open('https://discord.com/invite/glowsai', '_blank')}
                >
                  <Trans i18nKey="main.contactUs">Contact Us</Trans>
                </Button>
              }
            />
          </div>
        </div>
      </div>
    )
  }

  // Render child routes (DashboardView or ComputeView)
  return <Outlet />
}
